import { apiClient } from '@/services/apiClient';
import { useMutation } from '@tanstack/react-query';
import { Routes } from './routes';
import type { PaymentStatusResponse } from '@/types/payment';

interface GetStatusParams {
  paymentMethodId: string;
  sessionToken?: string;
  redirectResult?: string;
}

export const useGetStatus = () => {
  return useMutation({
    mutationFn: async (params: GetStatusParams): Promise<PaymentStatusResponse> => {
      const response = await apiClient.post<PaymentStatusResponse>(Routes.PAYMENT_STATUS, {
        sessionToken: params.sessionToken,
        redirectResult: params.redirectResult,
        paymentMethodId: params.paymentMethodId,
      });
      return response;
    },
  });
};
